import * as React from "react"
import Navbar from "./Navbar"
import Footer from "./Footer"
import "../assets/css/main.css"
import "normalize.css"
import { motion } from "framer-motion"
import { pageAnimation } from "../utils/animations"

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <motion.main
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        exit="exit"
      >
        {children}
      </motion.main>
      <Footer />
    </>
  )
}

export default Layout
